import type {
  ApparelBrand,
  ApparelBrandRequest,
  ApparelBrandsResponse,
  ApparelModel,
  ApparelModelRequest,
  ApparelModelsResponse,
  ApparelTypeFilter,
} from '@stryd/models';
import type {ClientConfig, HttpClient} from '../../http';

const apparelPath = `/b/admin/apparel`;

export const setupApparelEndpoints = (client: HttpClient) => {
  return {
    listBrands: (type: ApparelTypeFilter, config?: ClientConfig) => {
      return client.get<ApparelBrandsResponse, string>(
        `${apparelPath}/brands?type=${encodeURIComponent(type)}`,
        config
      );
    },

    listBrandModels: (
      brandId: string,
      type: ApparelTypeFilter,
      config?: ClientConfig
    ) => {
      return client.get<ApparelModelsResponse, string>(
        `${apparelPath}/brands/${encodeURIComponent(
          brandId
        )}/models?type=${encodeURIComponent(type)}`,
        config
      );
    },

    createBrand: (data: ApparelBrandRequest, config?: ClientConfig) => {
      return client.post<ApparelBrand, string>(
        `${apparelPath}/brands`,
        data,
        config
      );
    },

    updateBrand: (
      brandId: string,
      data: ApparelBrandRequest,
      config?: ClientConfig
    ) => {
      return client.put<ApparelBrand, string>(
        `${apparelPath}/brands/${encodeURIComponent(brandId)}`,
        data,
        config
      );
    },

    createBrandModel: (
      brandId: string,
      data: ApparelModelRequest,
      config?: ClientConfig
    ) => {
      return client.post<ApparelModel, string>(
        `${apparelPath}/brands/${encodeURIComponent(brandId)}/models`,
        data,
        config
      );
    },

    updateModel: (
      modelId: string,
      data: ApparelModelRequest,
      config?: ClientConfig
    ) => {
      return client.put<ApparelModel, string>(
        `${apparelPath}/models/${encodeURIComponent(modelId)}`,
        data,
        config
      );
    },
  };
};
